export const ANALYSED_VARIABLES_TABLE_ROW_TEMPLATE = '4fr 1fr 1fr 1fr'
